import React, { useState } from 'react'
import {
    CloudUploadIcon,
    DatabaseIcon,
    PaperAirplaneIcon,
    ServerIcon,
} from '@heroicons/react/solid'
import { SparklesIcon, CodeIcon, LightningBoltIcon } from '@heroicons/react/outline'
import ContactModal from './ContactModal'

import bgImg from '../Assets/cyber-bg.png'

const Home = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <>
            <div name='home' className='w-full min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50 flex flex-col justify-center pt-20'>
                <div className='max-w-[1400px] mx-auto px-4 md:px-8 py-12'>
                    <div className='grid md:grid-cols-2 gap-12 items-center'>
                        {/* Contenu texte */}
                        <div className='flex flex-col justify-center space-y-6 animate-fade-in'>
                            <div className='inline-flex items-center space-x-2 bg-indigo-50 px-4 py-2 rounded-full w-fit'>
                                <SparklesIcon className='h-5 w-5 text-indigo-600' />
                                <span className='text-sm font-medium text-indigo-600'>Solutions Digitales Innovantes</span>
                            </div>

                            <h1 className='text-5xl md:text-6xl lg:text-7xl font-bold leading-tight'>
                                <span className='text-gray-900'>Construire</span>
                                <br />
                                <span className='bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent'>Demain</span>
                                <br />
                                <span className='text-gray-900'>Maintenant</span>
                            </h1>

                            <p className='text-xl md:text-2xl text-gray-600 leading-relaxed max-w-xl'>
                                Des solutions technologiques sur mesure pour les particuliers et professionnels.
                                <span className='font-semibold text-gray-900'> Vous êtes les maîtres</span>, sans aucune limite.
                            </p>

                            <div className='flex flex-col sm:flex-row gap-4 pt-4'>
                                <button
                                    onClick={() => setIsModalOpen(true)}
                                    className='px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 transform hover:scale-105 shadow-lg text-lg font-medium w-full sm:w-auto'
                                >
                                    Démarrer un Projet
                                </button>
                                {/* <button className='px-8 py-4 border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50 transition-all duration-200 rounded-md text-lg font-medium w-full sm:w-auto'>
                                    En Savoir Plus
                                </button> */}
                            </div>

                            {/* Stats */}
                            <div className='grid grid-cols-3 gap-6 pt-8'>
                                <div>
                                    <p className='text-3xl font-bold text-indigo-600'>100%</p>
                                    <p className='text-sm text-gray-600'>Satisfaction</p>
                                </div>
                                <div>
                                    <p className='text-3xl font-bold text-indigo-600'>24/7</p>
                                    <p className='text-sm text-gray-600'>Disponible</p>
                                </div>
                                <div>
                                    <p className='text-3xl font-bold text-indigo-600'>10+</p>
                                    <p className='text-sm text-gray-600'>Projets</p>
                                </div>
                            </div>
                        </div>

                        {/* Image */}
                        <div className='relative'>
                            <div className='absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl transform rotate-3 opacity-20'></div>
                            <img className='relative w-full rounded-2xl shadow-2xl' src={bgImg} alt="Technology" />

                            {/* Floating cards */}
                            <div className='absolute -left-4 top-1/4 bg-white p-4 rounded-lg shadow-xl transform hover:scale-110 transition-transform duration-200'>
                                <CodeIcon className='h-8 w-8 text-indigo-600' />
                            </div>
                            <div className='absolute -right-4 top-1/2 bg-white p-4 rounded-lg shadow-xl transform hover:scale-110 transition-transform duration-200'>
                                <LightningBoltIcon className='h-8 w-8 text-purple-600' />
                            </div>
                        </div>
                    </div>

                    {/* Services Section */}
                    <div name='services' className='mt-24'>
                        <div className='text-center mb-12'>
                            <h2 className='text-3xl md:text-4xl font-bold text-gray-900 mb-4'>
                                Nos Services
                            </h2>
                            <p className='text-lg text-gray-600'>
                                Des solutions complètes pour réaliser vos ambitions digitales
                            </p>
                        </div>

                        <div className='grid sm:grid-cols-2 lg:grid-cols-4 gap-6'>
                            <div className='bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100'>
                                <div className='bg-gradient-to-br from-blue-500 to-blue-600 w-14 h-14 rounded-lg flex items-center justify-center mb-4'>
                                    <PaperAirplaneIcon className='h-7 w-7 text-white' />
                                </div>
                                <h3 className='text-xl font-bold text-gray-900 mb-2'>Conseils</h3>
                                <p className='text-gray-600'>
                                    Accompagnement stratégique pour votre transformation digitale
                                </p>
                            </div>

                            <div className='bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100'>
                                <div className='bg-gradient-to-br from-purple-500 to-purple-600 w-14 h-14 rounded-lg flex items-center justify-center mb-4'>
                                    <DatabaseIcon className='h-7 w-7 text-white' />
                                </div>
                                <h3 className='text-xl font-bold text-gray-900 mb-2'>Applications & Infrastructure</h3>
                                <p className='text-gray-600'>
                                    Création d'applications web et mobile sur mesure, modernes et performantes et également d'infrastructures cloud.
                                </p>
                            </div>

                            <div className='bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100'>
                                <div className='bg-gradient-to-br from-pink-500 to-pink-600 w-14 h-14 rounded-lg flex items-center justify-center mb-4'>
                                    <ServerIcon className='h-7 w-7 text-white' />
                                </div>
                                <h3 className='text-xl font-bold text-gray-900 mb-2'>Gestion de Données</h3>
                                <p className='text-gray-600'>
                                    Structuration et optimisation de vos bases de données
                                </p>
                            </div>

                            <div className='bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100'>
                                <div className='bg-gradient-to-br from-indigo-500 to-indigo-600 w-14 h-14 rounded-lg flex items-center justify-center mb-4'>
                                    <CloudUploadIcon className='h-7 w-7 text-white' />
                                </div>
                                <h3 className='text-xl font-bold text-gray-900 mb-2'>API</h3>
                                <p className='text-gray-600'>
                                    Développement d'APIs robustes et scalables pour connecter vos systèmes
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    )
}

export default Home